const footerLinks = [
  {
    title: '快速导航',
    items: [
      { label: '追更榜单', href: '#ranking' },
      { label: '热门话题', href: '#topics' },
      { label: '追更索引', href: '#index' },
      { label: '平台特色', href: '#features' },
    ],
  },
  {
    title: '关于我们',
    items: [
      { label: '平台介绍', href: '#about' },
      { label: '常见问题', href: '#faq' },
      { label: '追更指南', href: '#cards' },
      { label: '追更快讯', href: '#updates' },
    ],
  },
  {
    title: '更多内容',
    items: [
      { label: '精彩集锦', href: '#media' },
      { label: '读者热议', href: '#comments' },
      { label: '追更助手', href: '#app' },
      { label: '联系我们', href: '#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-200 border-t border-background-300/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <a href="#hero" className="font-heading text-xl font-bold text-primary-600">
              女神漫画网
            </a>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              女神漫画网追更频道实时同步连载漫画更新，覆盖热门韩漫日漫国漫，提供免费全集在线阅读与下拉式追更体验，第一时间推送最新话与连载动态，让追更更简单。
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mb-3">
                {group.title}
              </h3>
              <ul className="space-y-2">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-300/60 pt-8 mb-8">
          <h3 className="font-heading text-sm font-bold text-foreground-900 mb-4 text-center">
            合作伙伴
          </h3>
          <p className="text-xs text-foreground-500 text-center">
            感谢以下合作伙伴对女神漫画网的支持与信任，更多合作信息请联系我们。
          </p>
        </div>

        <div className="border-t border-background-300/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 女神漫画网. 专注连载漫画追更服务，韩漫日漫国漫免费全集持续更新。
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
              联系我们
            </a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
              常见问题
            </a>
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">
              返回顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}